
// Import css files
import { Link } from "react-router-dom";
import hammer from '../../../../../assets/images/hammer.png';
import React, { useEffect } from 'react';
import { Trans, useTranslation } from "react-i18next";
import { convertToCanadianDateTime, decodeHtmlEntities } from "../../../../../shared/helper";
import expiryclock from '../../../../../assets/images/expiryclock.svg';
const BankingArticleDetailsV3Jsx = (props) => {
  const {
    detailsData
  } = props;
  return (
    <>

<section className="bankinversionthreedetailblog">
        <div className="container">
          <div className="blogsectioone">
            <div className="row">
              <div className="col-lg-7 col-sm-7">
                <div className="blogsectiooneleft">
              
                  <div className="blogsectioleft">
                    <div className="title">
                      <h1>{decodeHtmlEntities(detailsData?.title?.rendered)}</h1></div>
                    <p>Enjoy daily banking with zero monthly fees, no minimum balance, and smart digital tools.</p>
                  </div>
                <div className="anptag"><p>{detailsData?.acf?.banner_sectionn.short_description}</p></div>
                <div className="d-flex userdetails">
                    <div className="userphoto">
                      <img src={`https://ui-avatars.com/api/?name=${detailsData?.['_embedded']?.['author']?.[0]?.name}&rounded=true`} alt={`${detailsData?.['_embedded']?.['author']?.[0]?.name}`} />
                    </div>
                    <div className="username">{detailsData?.['_embedded']?.['author']?.[0]?.name}</div>
                  </div>
                  </div>
              </div>
              <div className="col-lg-5 col-sm-5">
                <div className="blogsectioright">
                  <img src={detailsData?.acf?.banner_sectionn.image} alt="bannermage" />
                  
                </div>
                <p className="articlepublishdate mt-2"><span><img src={expiryclock} alt="clock" /></span>{convertToCanadianDateTime(detailsData?.date)}</p>
              </div>
            </div>

          </div>
          <div className="blogsectiontwo">
            <div className="row">
              <div className="col-lg-4 col-sm-4">
                <div className="psnapshot">
                  <h2>Product Snapshot</h2>
                  <table className="table psnapshotin">
                   <tr>
                     <td>1</td>
                     <td>Provider:</td>
                     <td>Tangerine Bank</td>
                   </tr>
                   <tr>
                     <td>2</td>
                     <td>Provider:</td>
                     <td>Tangerine Bank</td>
                   </tr>
                   <tr>
                     <td>3</td>
                     <td>Provider:</td>
                     <td>Tangerine Bank</td>
                   </tr>
                   <tr>
                     <td>4</td>
                     <td>Provider:</td>
                     <td>Tangerine Bank</td>
                   </tr>
                   <tr>
                     <td>5</td>
                     <td>Provider:</td>
                     <td>Tangerine Bank</td>
                   </tr>
                   <tr>
                     <td>6</td>
                     <td>Provider:</td>
                     <td>Tangerine Bank</td>
                   </tr>
                  </table>
                </div>
              </div>
              <div className="col-lg-4 col-sm-4">
                <div className="prosinner">
                  <ul>
                    <li>No monthly fees or minimum balance</li>
                    <li>Free Interac e-Transfers</li>
                    <li>Earn daily interest</li>
                    <li>Excellent mobile banking experience</li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4 col-sm-4">
                <div className="prosinner consinner">
                  <ul>
                    <li>No monthly fees or minimum balance</li>
                    <li>Free Interac e-Transfers</li>
                    <li>Earn daily interest</li>
                    <li>Excellent mobile banking experience</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="blogsectionthree">
            <div className="row">
              <div className="col-lg-3 col-sm-3">
                <h2>Features</h2>
              </div>
              <div className="col-lg-9 col-sm-9">
                <div className="blogsectionthreeright">
                  <div className="row">
                    <div className="col">
                      <div className="col-inner">
                        <div className="slnumber">1</div>
                        <div className="col-innerts">
                          <h4>Fee-Free Banking Perks</h4>
                          <p>No monthly fees, unlimited Interac e-Transfers, bill payments, and purchases—enjoy everyday banking without hidden charges or extra costs.</p>
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="col-inner">
                        <div className="slnumber">1</div>
                        <div className="col-innerts">
                          <h4>Fee-Free Banking Perks</h4>
                          <p>No monthly fees, unlimited Interac e-Transfers, bill payments, and purchases—enjoy everyday banking without hidden charges or extra costs.</p>
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="col-inner">
                        <div className="slnumber">1</div>
                        <div className="col-innerts">
                          <h4>Fee-Free Banking Perks</h4>
                          <p>No monthly fees, unlimited Interac e-Transfers, bill payments, and purchases—enjoy everyday banking without hidden charges or extra costs.</p>
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="col-inner">
                        <div className="slnumber">1</div>
                        <div className="col-innerts">
                          <h4>Fee-Free Banking Perks</h4>
                          <p>No monthly fees, unlimited Interac e-Transfers, bill payments, and purchases—enjoy everyday banking without hidden charges or extra costs.</p>
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="col-inner">
                        <div className="slnumber">1</div>
                        <div className="col-innerts">
                          <h4>Fee-Free Banking Perks</h4>
                          <p>No monthly fees, unlimited Interac e-Transfers, bill payments, and purchases—enjoy everyday banking without hidden charges or extra costs.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="blogsectionfour">
            <div className="row">
              <div className="col-lg-9 col-sm-9">
                <div className="blogsectionfourinner">
                  <h2>Ease of Use</h2>
                  <div className="row">
                  <div className="col-lg-4 col-sm-4">
                  <div className="blogsectionfourleftinner">
                    <h4>Easy and Secure Sign-Up:</h4>
                    <p>
                    Tangerine offers a seamless online sign-up process, allowing you to open a chequing account in under 10 minutes, all without needing to visit a branch. Whether at home or on the go, you can easily complete the setup from your own space. The user-friendly interface guides you step by step, ensuring a quick and convenient process without the hassle of physical branch visits.
                    </p>
                  </div>
                  </div>
                  <div className="col-lg-4 col-sm-4">
                  <div className="blogsectionfourleftinner">
                    <h4>Easy and Secure Sign-Up:</h4>
                    <p>
                    The Tangerine mobile app and desktop platform are designed for ease of use, featuring clean layouts and simple navigation. Both platforms offer real-time alerts, keeping you updated on transactions as they happen. You can organize your finances with intuitive spending categories, allowing for better budgeting and financial tracking. Additionally, biometric logins, such as fingerprint or face recognition, ensure quick and secure access to your account.
                    </p>
                  </div>
                  </div>
                  <div className="col-lg-4 col-sm-4">
                  <div className="blogsectionfourleftinner">
                    <h4>Easy and Secure Sign-Up:</h4>
                    <p>
                    Tangerine offers a seamless online sign-up process, allowing you to open a chequing account in under 10 minutes, all without needing to visit a branch. Whether at home or on the go, you can easily complete the setup from your own space. The user-friendly interface guides you step by step, ensuring a quick and convenient process without the hassle of physical branch visits.
                    </p>
                  </div>
                  </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-3">
                <h3>Verdict box</h3>
                <img src={hammer} className="hammer" alt={hammer}/>
                <p>If you’re comfortable with Digital Banking and want a no-fee, hassle-free experience, Tangerine’s chequing account is a fantastic choice. <br/><br/>It balances ease, security, and value beautifully.

                </p>
              </div>
            </div>
          </div>
          <div className="blogsectionfive">
            <div className="row">
              <div className="col-lg-3 col-sm-3">
                <h2>Value for Money</h2>
              </div>
              <div className="col-lg-9 col-sm-9">
                <div className="blogsectionfiveright">
                  <div className="row">
                  <div className="col-lg-4 col-sm-4">
                    <div className="blogsectionfiverightinner">
                      <span>A</span>
                      <p>No monthly fees, so you can bank without extra charges.</p>
                    </div>
                    <div className="blogsectionfiverightinner">
                      <span>B</span>
                      <p>No monthly fees, so you can bank without extra charges.</p>
                    </div>
                    <div className="blogsectionfiverightinner">
                      <span>C</span>
                      <p>No monthly fees, so you can bank without extra charges.</p>
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-4">
                    <div className="blogsectionfiverightinner">
                      <span>D</span>
                      <p>No monthly fees, so you can bank without extra charges.</p>
                    </div>
                    <div className="blogsectionfiverightinner">
                      <span>E</span>
                      <p>No monthly fees, so you can bank without extra charges.</p>
                    </div>
                    <div className="blogsectionfiverightinner">
                      <span>F</span>
                      <p>No monthly fees, so you can bank without extra charges.</p>
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-4">
                    <div className="blogsectionfiverightinner">
                      <span>G</span>
                      <p>No monthly fees, so you can bank without extra charges.</p>
                    </div>
                    <div className="blogsectionfiverightinner">
                      <span>H</span>
                      <p>No monthly fees, so you can bank without extra charges.</p>
                    </div>
                    <div className="blogsectionfiverightinner">
                      <span>I</span>
                      <p>No monthly fees, so you can bank without extra charges.</p>
                    </div>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>

  );
};

export default BankingArticleDetailsV3Jsx;